import DOMPurify from "dompurify";

const Aboutus = ({ data }) => {
  // Destructure for cleaner access
  const { title, desc, img } = data;

  // Reusable clip-path style
  const clipStyle = {
    clipPath: "polygon(27% 0, 100% 0, 100% 100%, 0% 100%)",
  };

  return (
    <section
      id="aboutus"
      className="relative mx-5 md:mx-14 mb-4 mt-5 md:mt-10 p-10 pt-1 py-5 sm:pt-0 sm:py-0 md:p-0 sm:pl-[4.6rem] md:pl-16 bg-[#f8f6f1] rounded-2xl grid md:grid-cols-2 sm:grid-cols-1 sm:h-[16rem] md:h-[27rem]"
    >
      {/* Content Section */}
      <div className="flex flex-col justify-center md:pb-10">
        <h1 className="text-lg sm:text-2xl md:text-5xl text-[#15363A] pt-5 md:pt-0 font-bold">
          <div
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
          />
        </h1>
        <div className="text-sm md:text-xl text-[#312D2D] pt-5 w-[95%] leading-relaxed">
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(desc) }} />
        </div>
      </div>

      {/* Image Section with Visual Effects */}
      <div className="relative hidden md:flex h-full overflow-hidden rounded-r-2xl">
        <div className="w-[97.2%] h-full relative">
          {/* Background Image Layer */}
          <img
            className="w-full h-full object-cover absolute grayscale-[20%]"
            style={{ ...clipStyle, zIndex: 1 }}
            src={img}
            alt="About Background"
          />

          {/* Brand Color Overlay */}
          <div
            className="absolute w-full h-full left-0 top-0 opacity-40"
            style={{
              ...clipStyle,
              backgroundColor: "#15363A",
              zIndex: 2,
            }}
          />

          {/* Foreground Featured Image */}
          <img
            className="w-full h-full object-cover absolute left-[1.5rem] transition-transform duration-500 hover:scale-105"
            style={{ ...clipStyle, zIndex: 3 }}
            src={img}
            alt="About Us Featured"
          />
        </div>
      </div>

      {/* Anchor for the next section scroll */}
      <div id="choose_us" className="absolute -bottom-20"></div>
    </section>
  );
};

export default Aboutus;
